import { Link } from 'react-router';
import Functions from '../../../functions';
import iconFile from '../../assets/images/icon_book.gif';
import type { ItemBook } from '../../lib/ItemUtil';
import ListBase, { type ListBaseProps } from '../lib/ListBase';

class BookList extends ListBase {
    constructor(props: ListBaseProps) {
        super(props);
        this.label = 'Book';
        this.icon = iconFile;
    }

    renderBody() {
        const { lang } = this.props;
        const item = this.props.item as ItemBook;
        const authors = item.author.map((author) => Functions.mlang(author, lang)).join(', ');
        return (
            <>
                <Link to={this.url}>{Functions.mlang(item.title, lang)}</Link>
                <br />
                {authors}
            </>
        );
    }
}

export default BookList;
